import Vue from "vue";
import App from "./App.vue";
import Ionic from "@ionic/vue";
import "@ionic/core/css/core.css";
import "@ionic/core/css/ionic.bundle.css";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";

Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.use(Ionic);
Vue.use(VeeValidate, {
  events: "change|blur"
});

const dictionary = {
  de: {
    messages: {
      email: "Keine gültige E-Mail",
      required: "Dieses Feld wird benötigt",
      min: "Mindestens 5 Zeichen sind erforderlich."
    }
  }
};

Validator.localize(dictionary);
const validator = new Validator();
validator.localize("de");

export const EventBus = new Vue();

new Vue({
  router,
  store,
  created() {
    store.dispatch("getDataFromEndpoint", {
      reload: true,
      app: this
    });
  },
  render: h => h(App)
}).$mount("#app");
